/**
 * 图层样式菜单动作（M3-14）。
 *
 * 参数对话框是后续 UI 任务；这里先接通「图层→投影/描边」的开关式入口——
 * 再点一次关闭，符合 PS「勾选式样式列表」的最简形态。
 */
import type { ActionRegistry } from './registry';
import type { AppStore } from '../store';
import { createSetEffectsCommand } from '../commands/layer-commands';
import { findLayer } from '../../document/draft';

function toggleEffect(
  store: AppStore,
  kind: 'dropShadow' | 'stroke',
  defaults: Record<string, number | string>,
): void {
  const document = store.document;
  const id = store.activeLayerId;
  if (document === null || id === null) return;
  const found = findLayer(document.root, id);
  if (found === null) return;

  const existing = found.layer.effects.find((e) => e.kind === kind);
  const next =
    existing === undefined
      ? [...found.layer.effects, { kind, enabled: true, params: defaults }]
      : found.layer.effects.map((e) => (e.kind === kind ? { ...e, enabled: !e.enabled } : e));
  store.dispatch(createSetEffectsCommand(id, next));
}

export function registerEffectActions(registry: ActionRegistry, deps: { store: AppStore }): void {
  registry.register({
    id: 'layer.toggleDropShadow',
    title: '投影',
    group: '图层',
    section: 3,
    order: 0,
    enabled: (s) => s.hasDocument,
    run: () => {
      toggleEffect(deps.store, 'dropShadow', {
        distance: 5,
        angle: 135,
        blur: 5,
        opacity: 0.75,
        color: '#000000',
      });
    },
  });

  registry.register({
    id: 'layer.toggleStroke',
    title: '描边',
    group: '图层',
    section: 3,
    order: 1,
    enabled: (s) => s.hasDocument,
    run: () => {
      toggleEffect(deps.store, 'stroke', {
        width: 3,
        position: 'outside',
        opacity: 1,
        color: '#ffffff',
      });
    },
  });
}
